import * as React from 'react';
import { __ } from 'react-i18n/lib';
import styled from 'styled-components';
import { rem } from 'polished';

import { Button } from '../General/Button';
import * as searchSrc from '../../../../assets/zemplin/search.svg';
import { OutsideClick } from '../../Defaults/OutsideClick';

import { SanitasSearchResultsViewer } from '../../..';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { SearchFormInput } from './SearchFormInput';

// Interfaces
interface SearchFormProps {
  searchResults: {
    productsResult: any;
    categoriesResult: any;
  };
  searchTerm: string;
  redirectToSearchResultPage: (e, type?: string) => void;
  handleSearchTermChange: (e) => void;
  handleFocus: () => void;
  resultsDropdownVisible: boolean;
  hideResultViewer: () => void;
  isMobile?: boolean;
  partialSearchProductsIsFetching: boolean;
  partialSearchCategoriesIsFetching: boolean;
  user: any;
  partialSearchCategoryProducts: any;
}

/*****************/

const SearchFormWrapper = styled.form`
  width: 100%;
  /* max-width: ${rem(579)}; */
  position: relative;
  z-index: 501;

  ${({ theme }) => theme.media(0, 'sm')} {
    padding-top: ${rem(8)};
    padding-bottom: ${rem(16)};
  }
`;

const SearchFormContainer = styled.div`
  display: flex;
  position: relative;
`;

const SearchFormInputWrapper = styled.div`
  flex: 1 0 auto;
  position: relative;
`;

const SearchFormSubmit = styled(Button)`
  transition: filter 0.2s ease;
  background: ${({ theme }) => theme.colors.tertiary};
  border-radius: ${rem(0)} ${rem(4)} ${rem(4)} ${rem(0)};
  position: relative;
  left: ${rem(-1)};
  font-size: ${rem(14)};
  line-height: 1.2857142857;

  &:hover {
    filter: brightness(90%);
  }

  ${({ theme }) => theme.media(0, 'sm')} {
    height: initial;
    padding: ${rem(10)} ${rem(24)} ${rem(11)} ${rem(24)};
    width: initial;
    position: absolute;
    left: auto;
    right: ${rem(16)};
    top: 0;
    bottom: 0;
  }
`;

const SearchFormSvgIcon = styled(SvgIcon)`
  position: absolute;
  top: 50%;
  left: ${rem(16)};
  transform: translate3d(0, -50%, 0);
  width: ${rem(24)};
  height: ${rem(24)};

  ${({ theme }) => theme.media(0, 'sm')} {
    display: none;
  }
`;

export const SearchFormIcon: any = styled.img`
  fill: #cccccc;
  position: absolute;
  top: 50%;
  left: ${rem(15)};
  transform: translate3d(0, -50%, 0);
  width: ${rem(24)};
  height: ${rem(24)};
`;

function SearchForm({
  searchResults,
  redirectToSearchResultPage,
  searchTerm,
  handleFocus,
  handleSearchTermChange,
  resultsDropdownVisible,
  hideResultViewer,
  isMobile = false,
  partialSearchProductsIsFetching,
  partialSearchCategoriesIsFetching,
  user,

  partialSearchCategoryProducts,
}: SearchFormProps) {
  return (
    <SearchFormWrapper autoComplete="off">
      <OutsideClick handleFunction={hideResultViewer}>
        <SearchFormContainer>
          <SearchFormInputWrapper>
            <SearchFormInput
              isMobile={isMobile}
              name="q"
              type="text"
              placeholder={__('Zadajte názov produktu alebo kategórie...')}
              value={searchTerm}
              onFocus={handleFocus}
              onChange={handleSearchTermChange}
            />
            <SanitasSearchResultsViewer
              partialSearchProductsIsFetching={partialSearchProductsIsFetching}
              partialSearchCategoriesIsFetching={
                partialSearchCategoriesIsFetching
              }
              visible={resultsDropdownVisible}
              searchResults={searchResults}
              searchTerm={searchTerm}
              redirectToResultPage={redirectToSearchResultPage}
              hideResultViewer={hideResultViewer}
              user={user}
              partialSearchCategoryProducts={partialSearchCategoryProducts}
            />
          </SearchFormInputWrapper>

          <SearchFormSubmit type="submit" onClick={redirectToSearchResultPage}>
            {__('Hľadať')}
          </SearchFormSubmit>

          {/* <SearchFormIcon
            onClick={redirectToSearchResultPage}
            src={searchSrc.toString()}
            fill="#cccccc"
          /> */}

          <SearchFormSvgIcon
            width={24}
            height={24}
            icon={IconType.search}
            alt="Hľadať"
            title="Hľadať"
            cursor={'pointer'}
            fill={'#888'}
            onClick={redirectToSearchResultPage}
          />
        </SearchFormContainer>
      </OutsideClick>
    </SearchFormWrapper>
  );
}

export { SearchForm };
